import { configureStore } from '@reduxjs/toolkit';
import auth from './auth';
import events from './events';
import matches from './matches';
import match from './match';
import players from './players';
import guestCode from './guestCode';
export const store = configureStore({
    reducer: {
        auth,
        events,
        matches,
        match,
        players,
        guestCode,
    },
});
